module.exports = __webpack_public_path__ + "img/settings-checked.8662ef22.svg";